// COMPONENTS
import Box from '@mui/material/Box'
import PanToolIcon from '@mui/icons-material/PanTool'

export default function DragIcon ({ sx: sxProp }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 0.75,
        py: 1,
        minWidth: 44,
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        cursor: 'grab',
        borderLeft: '1px solid',
        borderColor: 'rgba(255,255,255,0.15)',
        '&:active': { cursor: 'grabbing' },
        '&:hover': {
          bgcolor: 'primary.dark'
        },
        ...sxProp
      }}
    >
      <PanToolIcon sx={{ fontSize: 20, opacity: 0.95 }} />
    </Box>
  )
}
